import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./Home.scss";
import Footer from "../footer/Footer";
import { Header } from "../header/Header";
import HeroVideo from "../pages/HeroVideo/HeroVideo";
import StatsCounter from "../pages/Stats/StatsCounter";
import Offerings from "../pages/Offerings/Offerings";
import Portfolio from "../pages/Portfolio/Portfolio";
import ContactCTA from "../pages/ContactCTA/ContactCTA";
import ParallaxSection from "./ParallaxSection";
import SmoothScroll from "../../motion/SmoothScroll";
import monchromaticimage from "../../assests/our_services_assets/p_img.jpg";
import { usePagePreload } from "../../preload/usePagePreload";
import { HOME_IMAGES } from "../../preload/pageAssets";
import PageSkeleton from "../../preload/PageSkeleton";
// import monchromaticimage from "../../assests/our_services_assets//p_img4.jpg";
// import monchromaticimage from "../../assests/our_services_assets//p_img5.jpg";



const Home: React.FC = () => {
  const location = useLocation();
  const { ready } = usePagePreload(HOME_IMAGES);

  useEffect(() => {
    const state = location.state as { scrollTo?: string } | null;
    if (state?.scrollTo && ready) {
      // Short delay to let the page render before scrolling
      const timer = setTimeout(() => {
        const el = document.getElementById(state.scrollTo!);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }, 120);
      return () => clearTimeout(timer);
    }
  }, [location.state, ready]);

  if (!ready) {
    return <PageSkeleton cards={4} />;
  }

  return (
    <SmoothScroll>
    <div>
      <div className="appContainer">
        <Header />
          <HeroVideo />
      </div>
        <ParallaxSection images={[monchromaticimage, monchromaticimage, monchromaticimage]}>
          <StatsCounter />
          <Offerings />
          <Portfolio />
        </ParallaxSection>
        <ContactCTA />
      <Footer />
    </div>
    </SmoothScroll>
  );
};

export default Home;
